import type { TicketStatus, TicketCategory } from './types';
import { STATUS_DOT_COLORS, STATUS_TEXT_COLORS, STATUS_LABELS, CATEGORY_LABELS } from './constants';

interface Props {
  id: number;
  status: TicketStatus;
  category: TicketCategory | null;
  subject: string;
}

export function TicketHeader({ id, status, category, subject }: Props) {
  return (
    <div>
      <div className='flex items-center gap-3 mb-2'>
        <span className='font-mono-data text-xs text-muted-foreground'>
          #{id}
        </span>
        <span
          className='inline-flex items-center gap-1.5 text-xs font-medium font-mono-data'
          style={{ color: STATUS_TEXT_COLORS[status] }}
        >
          <span
            className='w-1.5 h-1.5 rounded-full shrink-0'
            style={{ backgroundColor: STATUS_DOT_COLORS[status], boxShadow: `0 0 6px ${STATUS_DOT_COLORS[status]}` }}
          />
          {STATUS_LABELS[status]}
        </span>
        {category && (
          <span
            className='inline-flex items-center px-1.5 py-0.5 rounded text-[11px] font-medium font-mono-data'
            style={{
              background: 'oklch(0.65 0.22 285 / 0.1)',
              color: 'oklch(0.65 0.22 285)',
              border: '1px solid oklch(0.65 0.22 285 / 0.25)',
            }}
          >
            {CATEGORY_LABELS[category]}
          </span>
        )}
      </div>
      <h1 className='text-xl font-bold font-syne'>
        {subject}
      </h1>
    </div>
  );
}
